/**
 * Vuex 入口
 *
 * 模块说明：
 * - user: 内部员工状态管理（原有）
 * - customerPortal: 客户门户状态管理（新增，独立于内部员工）
 *
 * @author LWX
 * @date 2026-03-23
 */

import Vue from 'vue'
import Vuex from 'vuex'
import user from './modules/user'
import customerPortal from './modules/customer-portal'
import getters from './getters'

Vue.use(Vuex)

const store = new Vuex.Store({
    modules: {
        user,
        customerPortal
    },
    getters
})

export default store